const gfoOptions = [
  { item: '113', name: '(113) Korlátolt felelősségű társaság' },
  { item: '114', name: '(114) Részvénytársaság' },
  { item: '116', name: '(116) Közkereseti társaság' },
  { item: '117', name: '(117) Betéti társaság' },
  { item: '129', name: '(129) Szövetkezet' },
  { item: '135', name: '(135) Erdőbirtokossági társulat' },
  { item: '136', name: '(136) Végrehajtói iroda' },
  { item: '137', name: '(137) Közjegyzői iroda' },
  { item: '141', name: '(141) Európai részvénytársaság' },
  { item: '142', name: '(142) Európai szövetkezet' },
  { item: '143', name: '(143) Európai gazdasági egyesülés' },
  { item: '226', name: '(226) Külföldi vállalkozás magyarországi fióktelepe' },
  { item: '227', name: '(227) Külföldi székhelyű európai gazdasági egyesülés magyarországi telephelye' },
  { item: '228', name: '(228) Egyéni cég' },
  { item: '231', name: '(231) Egyéni vállalkozó' },
  { item: '591', name: '(591) Egyesülés' },
  { item: '611', name: '(611) Külföldiek magyarországi közvetlen kereskedelmi képviselete' }
]

const gfoOptionsForFormSelect = [
  { value: '113', text: '(113) Korlátolt felelősségű társaság' },
  { value: '114', text: '(114) Részvénytársaság' },
  { value: '116', text: '(116) Közkereseti társaság' },
  { value: '117', text: '(117) Betéti társaság' },
  { value: '129', text: '(129) Szövetkezet' },
  { value: '135', text: '(135) Erdőbirtokossági társulat' },
  { value: '136', text: '(136) Végrehajtói iroda' },
  { value: '137', text: '(137) Közjegyzői iroda' },
  { value: '141', text: '(141) Európai részvénytársaság' },
  { value: '142', text: '(142) Európai szövetkezet' },
  { value: '143', text: '(143) Európai gazdasági egyesülés' },
  { value: '226', text: '(226) Külföldi vállalkozás magyarországi fióktelepe' },
  { value: '227', text: '(227) Külföldi székhelyű európai gazdasági egyesülés magyarországi telephelye' },
  { value: '228', text: '(228) Egyéni cég' },
  { value: '591', text: '(591) Egyesülés' },
  { value: '611', text: '(611) Külföldiek magyarországi közvetlen kereskedelmi képviselete' }
]

export { gfoOptions, gfoOptionsForFormSelect }
